module.exports = __webpack_public_path__ + "img/de_bg_5.08e818ba.jpeg";